export const DEFAULT_PAGE_SIZE = 20;
export const PAGINATION_OPTIONS = [20, 50, 100];
